var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAutoscale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M14 5.375V2.008L10.626 2l-.002.75 2.097.005-1.458 1.456q.285.246.53.53l1.457-1.454v2.088zM3.288 2.765 4.737 4.21a5 5 0 0 0-.53.531l-1.452-1.45-.005 2.099L2 5.389l.008-3.374h3.367v.75zm-.538 9.948 1.457-1.455q.245.285.53.53L3.28 13.246l2.097.005-.002.75L2 13.992v-3.367h.75zm9.962.522-1.449-1.446q.285-.246.53-.531l1.452 1.45.005-2.099.75.002-.008 3.374h-3.367v-.75zM7.519 5.2l-2.24 5.6h.92l.56-1.44h2.48l.56 1.44h.92L8.48 5.2zM8 6.24l.92 2.32H7.08z",
  clipRule: "evenodd"
})));
export default SvgAutoscale;